import OwnerModel from '../owner/owner-model';
import UserModel from '../user/user-model';
import PersonalinfoModel from '../personalinfo/personalinfo-model';
import ApiService from '../../services/api.service';
import MessageModel from '../message/message-model';
import SectionModel from '../section/section-model';
import EventquizModel from '../eventquiz/eventquiz-model';
import AddressModel from '../address/address-model';
import AppService from '../../services/app.service';
import MedialibraryModel from '../medialibrary/medialibrary-model';

export default class EventModel {
    id: number;
    name: string;
    description: string;
    status: string;
    owner: any;
    ownerCaption: string;
    parent: any;
    parentCaption: string;
    type: string;
    viewstyle: string;
    usecamera: string;
    extratime: string;
    messagestart: any;
    messagestartCaption: string;
    messageend: any;
    messageendCaption: string;
    customer: any;
    customerCaption: string;
    customerEmail: string;
    participant: any;
    participantLength: number;
    participantCaption: string;
    participantCurrent: any;
    section: any;
    section0: any;
    sectionLength: number;
    sectionCaption: string;
    sectionParent: any;
    event: any;
    eventLength: number;
    eventEnded: number;
    eventquiz: any;
    eventquizLength: number;
    eventquizAnswered: number;
    eventParticipantCurrent: any;
    address: any;
    addressLength: number;
    addressCaption: string;
    addressType: string;
    addressLinkpath: string;
    startdate: any;
    startdateFmt: string;
    enddate: any;
    enddateFmt: string;
    startenddateFmt: string;
    image: any;
    imageId: number;
    imageUrl: string;    
    astemplate: string;
    uid: string;
    progressStatus: string;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name;
        let parent = datarow.parent?.data? new EventModel(datarow.parent?.data) : datarow.parent;
        this.parent = parent?.id;
        this.parentCaption = parent?.name;
        this.type = datarow.type || 'quiz-online';
        this.viewstyle = datarow.viewstyle || 'onebyone';
        this.usecamera = datarow.usecamera || 'yes';
        this.extratime = datarow.extratime || 'no';
        let messagestart = datarow.messagestart?.data? new MessageModel(datarow.messagestart?.data) : datarow.messagestart;
        this.messagestart = messagestart?.id;
        this.messagestartCaption = messagestart?.name;
        let messageend = datarow.messageend?.data? new MessageModel(datarow.messageend?.data) : datarow.messageend;
        this.messageend = messageend?.id;
        this.messageendCaption = messageend?.name;
        let customer = datarow.customer?.data? new PersonalinfoModel(datarow.customer?.data) : datarow.customer;
        this.customer = customer?.id;
        this.customerCaption = customer?.name;
        this.customerEmail = customer?.email;
        this.participant = datarow.participant?.data?.map((d: any) => new PersonalinfoModel(d));
        this.participantLength = this.participant?.length;
        this.participantCaption = this.participantLength === 0? '' : this.participant?.[0].name + (this.participantLength>1? ', ...' : '');
        let participantCurrent = this.type?.includes('-public') && {id: +UserModel.getUserPersonalinfo(), name: UserModel.getUserPersonalinfoCaption()}
        this.participantCurrent = this.participant?.filter((d: any) => d.user === +UserModel.getUser())?.[0] || participantCurrent;
        this.section = datarow.section?.data?.map((d: any) => new SectionModel(d));
        this.section0 = this.section?.[0];
        this.sectionLength = this.section?.length || 0;
        this.sectionCaption = this.sectionLength===0? '' : this.section0?.name + (this.sectionLength>1? ', ...' : '');
        this.sectionParent = this.parent? this.section0?.id : null;
        this.event = datarow.event?.data?.map((d: any) => new EventModel(d));
        this.eventLength = this.event?.length || 0;
        this.eventEnded =  this.event?.filter((d: any) => d.enddate !== null).length || 0;
        this.eventquiz = datarow.eventquiz?.data?.map((d: any) => new EventquizModel(d));
        this.eventquizLength = this.eventquiz?.length || 0;
        this.eventquizAnswered =  this.eventquiz?.filter((d: any) => d.answer || d.quizanswer).length || 0;
        this.eventParticipantCurrent = this.event?.filter((d: any) => d.participant?.[0]?.id === this.participantCurrent?.id)?.[0];        
        this.address = datarow.address?.data?.map((d: any) => new AddressModel(d));
        this.addressLength = this.address?.length || 0;
        this.addressCaption = this.addressLength===0? '' : this.address?.[0]?.name + (this.addressLength>1? ', ...' : '');
        this.addressType = this.address?.[0]?.type;
        this.addressLinkpath = this.address?.[0]?.linkPath;
        this.startdate = datarow.startdate;
        this.startdateFmt = AppService.dateFormat(this.startdate ||'', 'd mon y t');
        this.enddate = datarow.enddate;
        this.enddateFmt = AppService.dateFormat(this.enddate ||'', this.startdate?.substring(0,10) === this.enddate?.substring(0,10)? 't' : 'd mon y t');
        this.startenddateFmt = this.startdateFmt + (this.enddateFmt? ' - ' + this.enddateFmt : '');
        this.image = datarow.image?.data?.map((d: any) => new MedialibraryModel(d))?.[0];
        this.imageId = this.image?.id;
        this.imageUrl = this.image? ((this.image.url?.startsWith('http')? '' : ApiService.svrUrl) + this.image.url) : '';
        this.astemplate = datarow.astemplate;
        this.uid = datarow.uid;
        this.progressStatus = (!this.parent && this.startdate && this.eventLength > 0 && this.eventLength===this.eventEnded && this.eventLength===this.participantLength) || (this.parent && this.enddate)? 'Done' : this.eventLength > 0 && this.startdate? 'On Progress' : 'Not Started';  
    } 
    
    public static url: string = '/event';
    public static caption: string = 'Event';
    public static endPoint: string = 'events' 
    public static endPointMedia: string = 'api::event.event';
 
    public static endPointFilter = (uid?: string) => {
        return ( 
            '?populate[owner][sort]=id' +
            '&populate[parent][sort]=id' +
            '&populate[section][populate]=quizquestion' +
            '&populate[section][populate]=section' +
            '&populate[customer][sort]=id' +
            '&populate[participant][populate]=user' +
            '&populate[event][populate]=event' +
            '&populate[event][populate]=participant' +
            '&populate[event][populate]=section' +
            '&populate[eventquiz][populate]=quizanswer' +
            '&populate[image][sort]=id' +
            '&populate[address][sort]=id' +
            (uid? '&filters[uid]=' + uid : '&filters[id]=')
        )
    }

    public static endPointFilter2 = (parentId: number, sectionId?: number) => {
        const user = UserModel.getUser();
        return ('?populate=*&sort=name&filters[participant][user][id]=' + user + '&filters[parent][id]=' + parentId + (sectionId? '&filters[section]=' + sectionId : ''));
    }

    public static endPointFilter3 = (participantId?: number) => {
        return ('?populate[customer][sort]=id&populate[participant][populate]=user&populate[messagestart][sort]=id&populate[messageend][sort]=id' + (participantId? '&populate[participant][filters][id]=' +participantId:'') + '&filters[id]=');
    }

    public static endPointFilterList = (astemplate?: string, parentId?: number) => {
        const owner = OwnerModel.getOwner();
        return ( 
            '?populate=*&sort=name' +
            '&filters[owner]=' + owner +
            '&filters[parent]' + (parentId? '=' + parentId : '[id][$null]=true') +
            '&filters[astemplate]=' + (astemplate || 'no')
        );
    }
    public static endPointFilterList2 = (personalinfoType?: string) => {
        const owner = OwnerModel.getOwner();
        const user = UserModel.getUser();
        return ('?populate=*&sort=name&filters[owner]=' + owner + '&filters[' + (personalinfoType || 'participant') + '][user][id]=' + user + '&filters[parent][id][$null]=true');
    }

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(),    
        parent: null,
        parentCaption: '',
        type: 'quiz-online',
        viewstyle: 'onebyone',
        usecamera: 'no',
        extratime: 'no',
        messagestart: null,
        messagestartCaption: '',
        messageend: null,
        messageendCaption: '',
        customer: null,
        customerCaption: '',
        customerEmail: '',
        participant: [],
        participantLength: 0,
        participantCaption: '',
        participantCurrent: [],
        section: [],
        section0: [],
        sectionLength: 0, 
        sectionCaption: '',
        sectionParent: null,
        event: [],
        eventLength: 0,
        eventEnded: 0,
        eventquiz: [],
        eventquizLength: 0,
        eventquizAnswered: 0,
        eventParticipantCurrent: [],
        address: [],
        addressLength: 0,
        addressCaption: '',
        addressType: '',
        addressLinkpath: '',
        startdate: null,
        startdateFmt: '',
        enddate: null,
        enddateFmt: '',
        startenddateFmt: '',
        image: null,
        imageId: 0,
        imageUrl: '',
        astemplate: 'yes',
        uid: '',
        progressStatus: 'Not Started',
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
        { name: 'startdate', required: true, minValue: '0' },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'progressStatus', caption: '', type: 'state', default: 'Done'},
        { name: 'status', caption: '', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'startdate', caption: 'Start Date', type: 'date' },
    ]

    public static columnPicklistCard = [
        { name: 'name', type: 'caption' },
        { name: 'description' },
        { name: 'startdate', type: 'datetime' },
        { name: 'status', type: 'state', default: 'active' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]

    public static optionType = [
        { name: 'quiz-online', caption: 'Quiz Online' },
        { name: 'quiz-online-public', caption: 'Quiz Online Open Public' },
        { name: 'quiz-offline', caption: 'Quiz Offline' },
        { name: 'meeting-online', caption: 'Meeting Online' },
        { name: 'meeting-online-public', caption: 'Meeting Online Open Public' },
        { name: 'meeting-offline', caption: 'Meeting Offline' },
        { name: 'party-online', caption: 'Party Online' },
        { name: 'party-online-public', caption: 'Party Online Open Public' },
        { name: 'party-offline', caption: 'Party Offline' },
    ]

    public static optionViewstyle = [
        { name: 'all', caption: 'Show All' },
        { name: 'onebyone', caption: 'Show One by One' },
        { name: 'all-canback', caption: 'Show All & Can Back' },
        { name: 'onebyone-canback', caption: 'Show One by One & Can back' },
    ]

    public static optionusecamera = [
        { name: 'yes', caption: 'Yes' },
        { name: 'no', caption: 'No' },
    ]

    public static optionExtratime = [
        { name: 'yes', caption: 'Yes' },
        { name: 'no', caption: 'No' },
    ]
}